"use strict";
/*
 * Created on 15. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var RealImpactValueConverter_1 = require("../../impact/conversions/RealImpactValueConverter");

var ReleaseTotalDTO_1 = require("../model/ReleaseTotalDTO");

var ApprovalStatusConverter_1 = require("./ApprovalStatusConverter");

var ImpactRecordConverter_1 = require("./ImpactRecordConverter");

var ReleaseActionFeasibilityConverter_1 = require("./ReleaseActionFeasibilityConverter");

var ReleaseTotalDTOConverter_1 = require("./ReleaseTotalDTOConverter");
/**
 * @author Radek Beran
 */


var ReleaseTotalDTOConverterImpl =
/*#__PURE__*/
function (_ReleaseTotalDTOConve) {
  _inherits(ReleaseTotalDTOConverterImpl, _ReleaseTotalDTOConve);

  function ReleaseTotalDTOConverterImpl(approvalStatusConverter, releaseActionFeasibilityConverter, impactRecordConverter, realImpactValueConverter) {
    var _this;

    _classCallCheck(this, ReleaseTotalDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseTotalDTOConverterImpl).call(this));
    _this.approvalStatusConverter = approvalStatusConverter;
    _this.releaseActionFeasibilityConverter = releaseActionFeasibilityConverter;
    _this.impactRecordConverter = impactRecordConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseTotalDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ReleaseTotalDTO_1.ReleaseTotalDTO(source.categoryId, source.priceZoneId, conversions.asObjectList(source, 'nestedPriceZoneIds', function (id) {
        return id;
      }), conversions.asObject(source, 'impact', function (doc) {
        return _this2.impactRecordConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'approvalStatus', function (doc) {
        return _this2.approvalStatusConverter.toObject(doc, conversions);
      }), conversions.asObjectList(source, 'actionFeasibilities', function (doc) {
        return _this2.releaseActionFeasibilityConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'realImpact', function (doc) {
        return _this2.realImpactValueConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      Object.assign(result, {
        categoryId: source.categoryId
      });
      Object.assign(result, {
        priceZoneId: source.priceZoneId
      });
      Object.assign(result, {
        nestedPriceZoneIds: conversions.asObjectArray(source, 'nestedPriceZoneIds', function (id) {
          return id;
        })
      });
      Object.assign(result, {
        impact: this.impactRecordConverter.toDocument(source.impact, conversions)
      });
      Object.assign(result, {
        approvalStatus: source.approvalStatus !== null ? this.approvalStatusConverter.toDocument(source.approvalStatus, conversions) : null
      });
      Object.assign(result, {
        actionFeasibilities: conversions.asObjectArray(source, 'actionFeasibilities', function (actionFeasibility) {
          return _this3.releaseActionFeasibilityConverter.toDocument(actionFeasibility, conversions);
        })
      });

      if (source.realImpact) {
        Object.assign(result, {
          realImpact: this.realImpactValueConverter.toDocument(source.realImpact, conversions)
        });
      }

      return result;
    }
  }]);

  return ReleaseTotalDTOConverterImpl;
}(ReleaseTotalDTOConverter_1.ReleaseTotalDTOConverter);

ReleaseTotalDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ApprovalStatusConverter_1.ApprovalStatusConverter, ReleaseActionFeasibilityConverter_1.ReleaseActionFeasibilityConverter, ImpactRecordConverter_1.ImpactRecordConverter, RealImpactValueConverter_1.RealImpactValueConverter])], ReleaseTotalDTOConverterImpl);
exports.ReleaseTotalDTOConverterImpl = ReleaseTotalDTOConverterImpl;